import paramUtil from './param_util.js';
//数值，日期，字符过滤
function FormatFieldType(value, typeNumber) {
	if (value == '' || value == undefined || value == null) {
		return value;
	}
	if (typeNumber == 'amount') {
		return FormatterAmount(value);
	}
	if (typeNumber == 'amountComma') {
		return FormatterAmountByComma(value);
	}
	if (typeNumber == 'price') {
		return FormatterPrice(value);
	}
	if (typeNumber == 'priceComma') {
		return FormatterPriceByComma(value);
	}
	if (typeNumber == 'billPrice') {
		return FormatterBillPrice(value);
	}
	if (typeNumber == 'changeRate') {
		return FormatterChangeRate(value);
	}
	if (typeNumber == 'lossRate') {
		return FormatterLossRate(value);
	}
	if (typeNumber == 'qualifiedRate') {
		return FormatterQualifiedRate(value);
	}
	if (typeNumber == 'date') {
		return FormatDate(value);
	}
	if (typeNumber == 'dateTime') {
		return FormatDateTime(value);
	}
	if (typeNumber == 'time') {
		return FormatTime(value);
	}
	if (typeNumber == 'remark') {
		return FromatterBr(value);
	}
	if (typeNumber == 'string') {
		return value;
	}
}
//日期过滤
function FormatDate(date) {
	if (date == undefined || date == "") {
		return "";
	}
	var Dt = new Date(date);

	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay;
};
//时间过滤
function FormatDateTime(date) {
	if (date == undefined || date == "") {
		return "";
	}
	var Dt = new Date(date);

	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay + " " + Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};
//时间延时--秒
function FormatDateTimeLateSecond(date, secondNumber) {
	if (date == undefined || date == "") {
		return "";
	}
	var newDate = new Date(date);
	var Dt = new Date(newDate.getTime() + Number(secondNumber) * 1000);
	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay + " " + Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};
//时间延时--天
function FormatDateTimeLateDay(date, dayNumber) {
	if (date == undefined || date == "") {
		return "";
	}
	var newDate = new Date(date);
	var Dt = new Date(newDate.getTime() + Number(dayNumber) * 24 * 3600 * 1000);

	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay + " " + Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};


//禁用状态
function FormatIsStop(value) {
	switch (value) {
		case "True":
		case true:
			return "已停用";
		case "False":
		case false:
			return "正常";
		default:
			return "";
	}
}
//验收单状态-对应的颜色
function FormatIsStopColor(value) {
	switch (value) {
		case "True":
		case true:
			return "cell-red";
		case "False":
		case false:
			return "";
		default:
			return "";
	}
}

function FormatAreaStatus(value) {
	switch (value) {
		case "0":
		case 0:
			return "已停用";
		case "1":
		case 1:
			return "正常";
		default:
			return "";
	}
}
//档案状态
function FormatBasicStatus(value) {
	switch (value) {
		case "0":
		case 0:
			return "已停用";
		case "1":
		case 1:
			return "正常";
		case "2":
		case 2:
			return "待审核";
		default:
			return "";
	}
}
//档案状态-对应的颜色
function FormatBasicStatusColor(value) {
	switch (value) {
		case "0":
		case 0:
			return "cell-red";
		case "1":
		case 1:
			return "cell-violet";
		case "2":
		case 2:
			return "cell-yellow";
		default:
			return "";
	}
}

function FormatRoomStatusColor(value) {
	switch (value) {
		case "服务中":
			return "roomcolor7 divRoomBox";
		case "休息":
			return "roomcolor1 divRoomBox";
		case "开房":
			return "roomcolor2 divRoomBox";
		case "停用":
			return "roomcolor3 divRoomBox";
		case "等待技师":
			return "roomcolor4 divRoomBox";
		case "预约":
			return "roomcolor5 divRoomBox";
		case "待扫":
			return "roomcolor8 divRoomBox";
		default:
			return "roomcolor6 divRoomBox";
	}
}


function FormatTechnicianStatusColor(value) {
	switch (value) {
		case "服务中":
			return "techniciancolor7 divTechnicianBox";
		case "休息":
			return "techniciancolor1 divTechnicianBox";
		case "停用":
			return "techniciancolor3 divTechnicianBox";
		case "等待上钟":
			return "techniciancolor4 divTechnicianBox";
		case "圈牌中":
			return "techniciancolor2 divTechnicianBox"; 
		case "下班":
			return "techniciancolor8 divTechnicianBox"; 
		default:
			return "techniciancolor6 divTechnicianBox";
	}
}

function FormatHandCardStatusColor(value) {
	switch (value) {
		case "结账未还":
			return "handCardcolor1 divTechnicianBox";
		case "停用":
			return "handCardcolor3 divTechnicianBox";
		case "申请未取":
			return "handCardcolor4 divTechnicianBox";
		case "申请已取":
			return "techniciancolor7 divTechnicianBox";
		default:
			return "handCardcolor6 divTechnicianBox";
	}
}



//审核状态（通用型）
function FormatBasicApprove(value) {
	switch (value) {
		case "0":
		case 0:
			return "待审核";
		case "1":
		case 1:
			return "已审核";
		default:
			return "";
	}
}
//审核状态-对应的颜色（通用型）
function FormatBasicApproveColor(value) {
	switch (value) {
		case "0":
		case 0:
			return "cell-yellow";
		case "1":
		case 1:
			return "cell-violet";
		default:
			return "";
	}
}

//备件申领单状态-对应的颜色
function FormatRepairProductApplyStatusColor(value) {
	switch (value) {
		case "待发料":
			return "cell-violet";
		case "待采购":
			return "cell-red";
		case "已发料":
			return "cell-green";
		default:
			return "";
	}
}

function FormatBasicRepairColor(value) {
	switch (value) {
		case "待派工":
			return "cell-yellow";
		case "待检测":
			return "cell-violet";
		case "待维修":
			return "cell-blue";
		case "待质检":
			return "cell-green";
		case "待出货":
			return "cell-red";
		default:
			return "";
	}
}
//备件信息-计价方式
function FormatCostAccountType(value) {
	switch (value) {
		case "1":
		case 1:
			return "移动加权平均";
		case "2":
		case 2:
			return "先进先出";
		case "3":
		case 3:
			return "个别计价";
		default:
			return "";
	}
}

//委外加工单 来源类型
function OMFromDocumentType(value) {
	switch (value) {
		case "1":
		case 1:
			return "计划单";
		case "2":
		case 2:
			return "打样单";
		case "3":
		case 3:
			return "销售订单";
		default:
			return "";
	}
}

//换行符过滤
function FromatterBr(value) {
	if (value != '' & value != undefined & value != null) {
		return value.replace(new RegExp("<br/>", "gm"), "\r\n");
	}
}
//数量小数
function FormatterAmount(value) {
	if (!paramUtil.SystemParam || !paramUtil.SystemParam.DecimalPlaces) {
		return;
	}
	let limitNumber = paramUtil.SystemParam.DecimalPlaces.Amount;
	if (value == undefined || value == null || value.toString() == '') {
		return 0;
	}
	if (paramUtil.SystemParam.DecimalPlaces.IsAmountGiveUpZero) {
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	}
	var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
	if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
		return s;
	}
	while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
		s += '0';
	}
	return s;
}
//单价小数
function FormatterPrice(value) {
	if (!paramUtil.SystemParam || !paramUtil.SystemParam.DecimalPlaces) {
		return;
	}
	let limitNumber = paramUtil.SystemParam.DecimalPlaces.Price;
	if (value == undefined || value == null || value.toString() == '') {
		return 0;
	}
	if (paramUtil.SystemParam.DecimalPlaces.IsPriceGiveUpZero) {
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	}
	var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
	if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
		return s;
	}
	while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
		s += '0';
	}
	return s;
}
//发票单价小数
function FormatterBillPrice(value) {
	if (!paramUtil.SystemParam || !paramUtil.SystemParam.DecimalPlaces) {
		return;
	}
	let limitNumber = paramUtil.SystemParam.DecimalPlaces.BillPrice;
	if (value == undefined || value == null || value.toString() == '') {
		return 0;
	}
	if (paramUtil.SystemParam.DecimalPlaces.IsBillPriceGiveUpZero) {
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	}
	var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
	if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
		return s;
	}
	while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
		s += '0';
	}
	return s;
}
//换算率小数
function FormatterChangeRate(value) {
	if (!paramUtil.SystemParam || !paramUtil.SystemParam.DecimalPlaces) {
		return;
	}
	let limitNumber = paramUtil.SystemParam.DecimalPlaces.ChangeRate;
	if (value == undefined || value == null || value.toString() == '') {
		return 0;
	}
	if (paramUtil.SystemParam.DecimalPlaces.IsChangeRateGiveUpZero) {
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	}
	var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
	if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
		return s;
	}
	while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
		s += '0';
	}
	return s;
}
//损耗率小数
function FormatterLossRate(value) {
	if (!paramUtil.SystemParam || !paramUtil.SystemParam.DecimalPlaces) {
		return;
	}
	let limitNumber = paramUtil.SystemParam.DecimalPlaces.LossRate;
	if (value == undefined || value == null || value.toString() == '') {
		return 0;
	}
	if (paramUtil.SystemParam.DecimalPlaces.IsLossRateGiveUpZero) {
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	}
	var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
	if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
		return s;
	}
	while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
		s += '0';
	}
	return s;
}
//合格率小数
function FormatterQualifiedRate(value) {
	if (!paramUtil.SystemParam || !paramUtil.SystemParam.DecimalPlaces) {
		return;
	}
	let limitNumber = paramUtil.SystemParam.DecimalPlaces.QualifiedRate;
	if (value == undefined || value == null || value.toString() == '') {
		return 0;
	}
	if (paramUtil.SystemParam.DecimalPlaces.IsQualifiedRateGiveUpZero) {
		return (Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)
	}
	var s = ((Number(value) * Math.pow(10, limitNumber)).toFixed(0) / Math.pow(10, limitNumber)).toString();
	if (s.split('.')[1] && s.split('.')[1].length == limitNumber) {
		return s;
	}
	while (s.split('.')[1] && s.split('.')[1].length < limitNumber) {
		s += '0';
	}
	return s;
}
//时间过滤
function FormatTime(date) {
	if (date == undefined || date == "") {
		return "";
	}
	var Dt = new Date(date);

	return Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};
//抛出接口
export default {
	FormatDate,
	FormatDateTime,
	FormatDateTimeLateSecond,
	FormatDateTimeLateDay,
	FromatterBr,
	FormatIsStop,
	FormatIsStopColor,
	FormatAreaStatus,
	FormatBasicStatus,
	FormatBasicStatusColor,
	FormatRoomStatusColor,
	FormatBasicApprove,
	FormatBasicApproveColor,
	FormatRepairProductApplyStatusColor,
	FormatTechnicianStatusColor,
	FormatHandCardStatusColor,
	FormatBasicRepairColor,
	FormatCostAccountType,
	OMFromDocumentType,
	FormatFieldType,
	FormatterAmount,
	FormatterPrice,
	FormatterBillPrice,
	FormatterChangeRate,
	FormatterLossRate,
	FormatterQualifiedRate
}



// WEBPACK FOOTER //
// ./src/common/js/filter.js